import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { pushTrackingEvent } from '../../actions/tracking/tracking.actions'
import trackingSelector from '../../selectors/tracking/trackingSelector'
import isTrackingEnabledSelector from '../../selectors/feature-scope/isTrackingEnabledSelector'
import { logger } from '../../../utils/dccLogger'

const trackingPushMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)

    if (isActionOf(pushTrackingEvent, action)) {
        const state = store.getState()
        const isTrackingEnabled = isTrackingEnabledSelector(state)

        if (!isTrackingEnabled) {
            logger.info('Tracking event skipped - tracking disabled for this brand/context')
            return
        }

        if (window.digitalData !== undefined) {
            const dataLayerEvent = action.payload
            const tracking = trackingSelector(state)

            window.digitalData = {
                ...window.digitalData,
                ...tracking,
            }

            window.digitalData.event.push(dataLayerEvent)
        }
    }
}

export default trackingPushMiddleware
